import { topicList,topicProductList } from '../../api/topic'

// initial state
const state = {
	topicAllProducts: []
}

// mutations
const mutations = {
	saveTopicAllProducts(state, data) {
		state.topicAllProducts = data
	}
}

// actions 
const actions = {
	fetchTopicAllProduct({ commit, state }, params) {
		return new Promise((resolve, reject) => {
			topicList(params.display_area,params.page, params.per_page,params.topic_id).then(
				response => {
					if (response) {
						// commit('saveTopicAllProducts', response.topic)
					}
					resolve(response)
				},
				error => {
					reject(error)
				}
			)
		})
	}
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/topic.js